import { useTranslation } from 'react-i18next';
import { Button } from '../../components/common/Button';

export function ReportFilterActions({ onReset, onSearch }: { onReset: () => void; onSearch: () => void }) {
  const { t } = useTranslation();
  return (
    <div className="rpt-filter-actions">
      <Button variant="outline" onClick={onReset}>
        {t('reports.reset')}
      </Button>
      <Button variant="primary" onClick={onSearch}>
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
          <circle cx="11" cy="11" r="8" />
          <line x1="21" y1="21" x2="16.65" y2="16.65" />
        </svg>
        {t('reports.search')}
      </Button>
    </div>
  );
}
